var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
import { enableProdMode } from '@angular/core';
import { environment } from '@environments/environment';
import { console } from '@app/shared/util/console.util';
import { fetchWithRetry, clearGisAuthRetryCounter, incrementGisAuthRetryCounter } from '@app/modules/gis/gis-token';
import { applyEsriTokenPatch } from '@app/modules/gis/esri-token-patch';
import 'hammerjs';
import * as __NgCli_bootstrap_1 from "./app/app.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
/**
 * PKCE token exchange — runs BEFORE Angular (and MSAL) bootstraps.
 *
 * When the GIS Portal redirects back after authorization it appends
 * ?code=AUTH_CODE as a query parameter (not a hash fragment, so MSAL is
 * unaffected). We intercept it here, exchange the code for tokens via a
 * direct POST to the Portal token endpoint, persist them in sessionStorage,
 * and clean the URL before handing control to Angular.
 *
 * On successful exchange, clears the retry counter (full auth succeeded).
 * On permanent auth failure (no access_token), increments retry counter.
 * Transient errors (network, 5xx, 429) are handled by fetchWithRetry.
 */
function exchangeGisPkceCode() {
    return __awaiter(this, void 0, void 0, function () {
        var urlParams, code, verifier, portalUrl, appId, body, res, data, err_1, returnUrl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    urlParams = new URLSearchParams(window.location.search);
                    code = urlParams.get('code');
                    if (!code) {
                        return [2 /*return*/];
                    }
                    verifier = sessionStorage.getItem('geobrain_gis_code_verifier');
                    portalUrl = sessionStorage.getItem('geobrain_gis_portal_url');
                    appId = sessionStorage.getItem('geobrain_gis_app_id');
                    // Always clear these one-time-use keys from sessionStorage
                    sessionStorage.removeItem('geobrain_gis_code_verifier');
                    sessionStorage.removeItem('geobrain_gis_portal_url');
                    sessionStorage.removeItem('geobrain_gis_app_id');
                    // Only clean the URL after confirming this ?code= belongs to us.
                    // If there is no GIS verifier the code is not ours — leave the URL intact
                    // so any other handler (e.g. MSAL) can still read it.
                    if (!verifier || !portalUrl || !appId) {
                        return [2 /*return*/];
                    }
                    history.replaceState(null, '', window.location.pathname);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    body = new URLSearchParams({
                        client_id: appId,
                        code: code,
                        redirect_uri: window.location.origin + '/',
                        grant_type: 'authorization_code',
                        code_verifier: verifier
                    });
                    return [4 /*yield*/, fetchWithRetry(portalUrl + "/sharing/oauth2/token?f=json", {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                            body: body.toString()
                        })];
                case 2:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 3:
                    data = _a.sent();
                    if (data.access_token) {
                        sessionStorage.setItem('geobrain_gis_access_token', data.access_token);
                        sessionStorage.setItem('geobrain_gis_token_expiry', (Date.now() + data.expires_in * 1000).toString());
                        if (data.refresh_token) {
                            sessionStorage.setItem('geobrain_gis_refresh_token', data.refresh_token);
                            if (data.refresh_token_expires_in) {
                                sessionStorage.setItem('geobrain_gis_refresh_token_expiry', (Date.now() + data.refresh_token_expires_in * 1000).toString());
                            }
                        }
                        // Clear retry counter on successful exchange
                        clearGisAuthRetryCounter();
                    }
                    else {
                        console.log('GIS PKCE token exchange failed: no access_token in response:', data);
                        // Permanent auth failure (invalid code, expired code, etc.) — increment retry counter
                        incrementGisAuthRetryCounter();
                    }
                    return [3 /*break*/, 5];
                case 4:
                    err_1 = _a.sent();
                    // All retries exhausted (network failure, timeout, etc.) — still counts as a failed attempt
                    console.log('GIS PKCE token exchange failed after retries:', err_1);
                    incrementGisAuthRetryCounter();
                    return [3 /*break*/, 5];
                case 5:
                    returnUrl = sessionStorage.getItem('geobrain_gis_return_url') || '/';
                    sessionStorage.removeItem('geobrain_gis_return_url');
                    history.replaceState(null, '', returnUrl);
                    return [2 /*return*/];
            }
        });
    });
}
(function () { return __awaiter(_this, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, exchangeGisPkceCode()];
            case 1:
                _a.sent();
                applyEsriTokenPatch();
                if (environment.production) {
                    enableProdMode();
                }
                __NgCli_bootstrap_2.platformBrowser().bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory)
                    .catch(function (err) { return console.log(err); });
                return [2 /*return*/];
        }
    });
}); })();
